// adapted from: https://gist.github.com/akozhemiakin/731b0c1e99eb89b01f80f08f9146b6b6
import { ApolloError } from '@apollo/client/core';
import apolloClient from './apolloClient';
import { getSdk } from './generated/sdk';
const validDocDefOps = ['mutation', 'query', 'subscription'];
function getApolloSdk(client) {
    const requester = async (doc, variables, options) => {
        // Valid document should contain *single* query or mutation unless it's has a fragment
        if (doc.definitions.filter(d => d.kind === 'OperationDefinition' &&
            validDocDefOps.includes(d.operation)).length !== 1) {
            throw new TypeError('DocumentNode passed to Apollo Client must contain single query or mutation');
        }
        const definition = doc.definitions[0];
        // Valid document should contain *OperationDefinition*
        if (definition.kind !== 'OperationDefinition') {
            throw new TypeError('DocumentNode passed to Apollo Client must contain single query or mutation');
        }
        switch (definition.operation) {
            case 'mutation': {
                const response = await client.mutate({
                    mutation: doc,
                    variables,
                    ...options,
                });
                if (response.errors) {
                    throw new ApolloError({ graphQLErrors: response.errors });
                }
                if (response.data === undefined || response.data === null) {
                    throw new Error('No data presented in the GraphQL response');
                }
                return response.data;
            }
            case 'query': {
                const response = await client.query({
                    query: doc,
                    variables,
                    ...options,
                });
                if (response.errors) {
                    throw new ApolloError({ graphQLErrors: response.errors });
                }
                if (response.data === undefined || response.data === null) {
                    throw new Error('No data presented in the GraphQL response');
                }
                return response.data;
            }
            default: throw new TypeError(`Unsupported graphql operation: ${definition.operation}`);
        }
    };
    return getSdk(requester);
}
const apolloSdk = getApolloSdk(apolloClient);
export default apolloSdk;
